import builder from '../builder';
import Dishwasher from '../../streamline-icons/bold/dishwasher.svg';

export default builder('IconDishwasherBold', Dishwasher);
